export * from './email-validation-error';
export * from './form-dialog-title';
export * from './is-busy-button';
export * from './text-input';
export * from './number-input';
export * from './name-taken-validation-error';
export * from './required-validation-error';
export * from './pattern-validation-error';
export * from './max-validation-error';
export * from './min-validation-error';
export * from './text-box';
export * from './rich-text-input';

import { EmailValidationErrorComponent } from './email-validation-error';
import { FormDialogTitleComponent } from './form-dialog-title';
import { IsBusyButtonComponent} from './is-busy-button';
import { NameTakenValidationErrorComponent } from './name-taken-validation-error';
import { RequiredValidationErrorComponent } from './required-validation-error';
import { TextInputComponent } from './text-input';
import { CheckboxComponent } from './checkbox';
import { PatternValidationErrorComponent } from './pattern-validation-error';
import { NumberInputComponent } from './number-input';
import { MaxValidationErrorComponent } from './max-validation-error';
import { MinValidationErrorComponent } from './min-validation-error';
import { TextBoxComponent } from './text-box';
import { RichTextInputComponent } from './rich-text-input';

export const FormAtoms = [
    EmailValidationErrorComponent,
    FormDialogTitleComponent,
    IsBusyButtonComponent,
    TextInputComponent,
    NameTakenValidationErrorComponent,
    RequiredValidationErrorComponent,
    CheckboxComponent,
    PatternValidationErrorComponent,
    NumberInputComponent,
    MaxValidationErrorComponent,
    MinValidationErrorComponent,
    TextBoxComponent,
    RichTextInputComponent,
]